import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { startDownloadData } from "../../../libs/utils";
import { FormattedMessage } from "react-intl";
import { updateReadCustomer } from "../../../store/actions/documentsWithSearch/index";
import { getDocumentType } from "../../../store/actions/documents/classification";
import {
  downloadDocument,
  resetDownloadDocument
} from "../../../store/actions/download/index";
import DownloadProgress from "../../downloadProgress/index";

import CardBlock from "./card/cardBlock";
import ListBlock from "./list/listBlock";

import "./../style.css";
import InfoModal from "../../uploader/infoModal";
import BannerNotFound from "../../../assets/img/banner-notfound.png";

const Results = props => {
  const {
    documentView,    
    myType,
    documentsLoaded
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // BEGIN REDUX STATE
  const download = useSelector(state => state.download);
  const results = useSelector(state => state.documentsWithSearch.results);
  const documents = useSelector(state => state.documents);
  // END REDUX STATE

  const [errorFile, setErrorFile] = useState(false);
  const [visibleDialog, setVisibleDialog] = useState(false);

  useEffect(() => {
    if (
      download.status.ended === true &&
      download.content.content === null &&
      download.content.filename === null
    ) {
      setErrorFile(true);
      setVisibleDialog(true);
    }
  }, [download]);

  useEffect(() => {
    if (!download.status.ended || !download.content) return;
    startDownloadData(download);
    dispatch(resetDownloadDocument());
  }, [download]);

  useEffect(() => {
    if (documentsLoaded) {
      if (documents && documents.classification !== undefined) {
        if (documents.classification.typesDocuments.types === null) {
          dispatch(getDocumentType());
        }
      } else {
        dispatch(getDocumentType());
      }
    }
  }, [documentsLoaded]);

  const getDownload = (
    e, documentId, filename, outputFormat, isEinvoice
  ) => {
    const fileN = filename && filename.split(".");
    e.stopPropagation();
    dispatch(downloadDocument(
      documentId,
      isEinvoice ? fileN[0] : filename,
      isEinvoice,
      outputFormat
    ));
    if (myType !== "STUDIO") {
      dispatch(updateReadCustomer(documentId));
    }
  };

  const documentsList = () => {
    results.list.map((item, key) => {
      return localStorage.setItem("subtitle-" + item.documentId,
        item.subtitle ? item.subtitle : item.title);
    });
    return results.list.map((item, key) =>
      documentView === "grid" ? (
        <CardBlock
          getDownload={getDownload}
          handleClick={handleClick}
          item={item}
          key={key}
          results={results}
        />
      ) : (
        <ListBlock
          getDownload={getDownload}
          handleClick={handleClick}
          item={item}
          key={key}
        />
      ));
  };
  const handleClick = (e, documentId) => {
    e.stopPropagation();
    e.preventDefault();
    if (myType !== "STUDIO") {
      dispatch(updateReadCustomer(documentId));
    }
    navigate("/dettaglio-documento/" + documentId);
  };

  const errorMessage = (
    <span>
      {" "}
      File non conforme. Si prega di eliminarlo e ricaricarlo. <br></br>
      <a href="https://agyo.elevio.help/it/articles/630-digital-box-caricamento-file-non-conforme">
        Scopri di più.
      </a>
    </span>
  );

  return results.list && results.list.length > 0 ? (
    <React.Fragment>
      {documentsList()}
      {errorFile && (
        <InfoModal
          title={"File non conforme"}
          content={errorMessage}
          isVisible={visibleDialog}
          type="primary"
          onClose={() => setVisibleDialog(false)}
        />
      )}
      {download.status.started && <DownloadProgress downloadState={download} />}
    </React.Fragment>
  ) : (
    <div className="documentWithSearch-banner-not-found">
      <div><img src={BannerNotFound} alt="" /></div>
      <div><FormattedMessage id="documents.noResults_filtered" /></div>
    </div>
  );
};

export default Results;
